<div class="d-inline-block">
  <div>{{object.display}}</div>
  <div *ngIf="uri"><a target="_blank" [href]="uri.value">{{uri.value}}</a></div>
</div>
